import React from 'react';
import { Link } from 'react-router-dom';
import { FaFileAlt, FaUpload } from 'react-icons/fa';
import './PartnerDemoPages.css';

const DEMO_DOCUMENTS = [
  { id: '1', name: 'ISO 27001 Certificate 2024', type: 'Certificate', uploaded: '2025-01-10', status: 'Active' },
  { id: '2', name: 'SOC 2 Type II Report', type: 'Report', uploaded: '2024-11-05', status: 'Active' },
  { id: '3', name: 'Data Processing Agreement', type: 'Contract', uploaded: '2024-09-01', status: 'Active' },
  { id: '4', name: 'QCB Compliance Letter', type: 'Letter', uploaded: '2025-01-02', status: 'Active' },
];

export default function DemoPartnerDocuments() {
  return (
    <div className="partner-demo-page">
      <nav className="page-breadcrumb">
        <Link to="/">Home</Link>
        <span className="mx-2">/</span>
        <span>Document management</span>
      </nav>
      <header className="page-header d-flex flex-wrap justify-content-between align-items-start gap-2">
        <div>
         
          <p className="page-subtitle mb-0">
            Upload and manage certificates and supporting documents.
          </p>
        </div>
        <button type="button" className="btn btn-partner-primary">
          <FaUpload className="me-2" />
          Upload document
        </button>
      </header>

      <div className="card-partner">
        <div className="card-header-partner">Your documents</div>
        <div className="card-body-partner p-0">
          <table className="table-partner">
            <thead>
              <tr>
                <th>Document name</th>
                <th>Type</th>
                <th>Uploaded</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {DEMO_DOCUMENTS.map((d) => (
                <tr key={d.id}>
                  <td>
                    <FaFileAlt className="me-2 text-muted" style={{ fontSize: '0.9rem' }} />
                    {d.name}
                  </td>
                  <td><span className="badge-partner badge-info">{d.type}</span></td>
                  <td>{d.uploaded}</td>
                  <td><span className="badge-partner badge-success">{d.status}</span></td>
                  <td><button type="button" className="btn btn-partner-outline btn-sm">View</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
